import { baseUrls } from '../../../../utils/baseUrls.utils';

export const returnListUrl = baseUrls.publisher.userGuideScopes.list;
